import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkLZfmfb3rgpJlvtTwJDZvrEX2HZVTAkg",
  authDomain: "psychometric-app-304df.firebaseapp.com",
  projectId: "psychometric-app-304df",
  storageBucket: "psychometric-app-304df.firebasestorage.app",
  messagingSenderId: "999649594456",
  appId: "1:999649594456:web:566424164fdce4d20ece2d",
  measurementId: "G-XKH5FFHXTH"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);